<template>
  <section>
    <v-toolbar class="box-shadow">
      <v-text-field hide-details outlined clearable placeholder="Search" dense v-model="search"></v-text-field>
<!--      <v-btn class="ml-3 box-shadow" color="primary" @click="create_item_dialog = !create_item_dialog">Create new</v-btn>-->
    </v-toolbar>

    <v-container fluid>
      <v-card>

        <v-divider></v-divider>
        <v-data-table :headers="table_data.headers"
                      :items="table_data.items"
                      :search="search">
          <template v-slot:item.actions="{ item }">
            <v-icon class="mr-2" @click="openSelectedItemDialog(item)">mdi-pencil</v-icon>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="create_item_dialog" max-width="500px" @click:outside="closeCreateItemDialog">
        <v-form class="text-center" @submit="createItem">
          <v-card class="box-shadow">
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="closeCreateItemDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>Create</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn dark text type="submit" color="success">Save</v-btn>
              </v-toolbar-items>
            </v-toolbar>

            <v-card-text>
              <v-select label="Session type"
                        v-model="new_item.session_type_id"
                        :items="available_session_types"
                        item-text="name"
                        item-value="id"
              ></v-select>

              <v-text-field
                  v-model="new_item.price"
                  type="number"
                  label="Price"
                  :error-messages="api_errors['price']"
              />

              <CriteriaTreeField v-model="new_item.criteria"/>
            </v-card-text>
          </v-card>
        </v-form>
      </v-dialog>

      <v-dialog v-model="selected_item_dialog" max-width="500px" @click:outside="closeSelectedItemDialog">
        <v-form v-if="selected_item" @submit="updateSelectedItem">
          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="closeSelectedItemDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>Edit</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>

            <v-card-text>
              <v-select :items="type_options"
                        label="Type"
                        v-model="selected_item.type"
                        disabled
              ></v-select>

              <v-select :items="status_options" label="Status"
                        v-model="selected_item.status"
                        :error-messages="api_errors['status']"
              ></v-select>

              <v-text-field v-model="selected_item.short_name" label="Short name"
                            :error-messages="api_errors['short_name']"
              />

              <v-text-field v-model="selected_item.name" label="Name"
                            :error-messages="api_errors['name']"
              />

              <v-text-field
                  v-model="selected_item.price"
                  type="number"
                  label="Price"
                  :error-messages="api_errors['price']"
              />

              <CriteriaTreeField v-model="selected_item.criteria"/>
            </v-card-text>
            <v-divider/>
            <v-card-actions class="justify-space-between">
<!--              <v-btn class="box-shadow" dark color="red" @click="deleteSelectedItem">Delete</v-btn>-->
              <v-btn class="box-shadow" color="success" type="submit">Update</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-container>
  </section>
</template>

<script>
  import {mapGetters} from "vuex";
  import CriteriaTreeField from "@/components/CriteriaTreeField";

  export default {
    components: {CriteriaTreeField},
    data: () => ({
      table_data: {
        headers: [
          { text: 'Type of Exercise', value: 'name' },
          { text: 'Short Name', value: 'short_name' },
          { text: 'Session Type', value: 'type' },
          { text: 'Price', value: 'price' },
          { text: 'Status', value: 'status' },
          { text: 'Actions', value: 'actions', sortable: false },
        ],
        items: []
      },
      type_options: [
        { text: 'Group Session', value: 'group' },
        { text: 'Individual Session', value: 'individual' },
      ],
      exercises: [
        'Client Interview',
        'Advocacy/Presentation',
        'Suggested answer',
        'Individually marked',
      ],
      status_options: [
        { text: 'Independent', value: 'independent' },
        { text: 'Dependent', value: 'dependent' },
      ],

      search: '',
      create_item_dialog: false,
      new_item: {
        session_type_id: '',
        price: '',
        criteria: []
      },
      selected_item_dialog: false,
      selected_item: null,

      api_errors: [],
    }),
    computed: {
      ...mapGetters({
        session_types: 'getSessionTypes',
      }),
      available_session_types: function () {
        let items = []

        let filtered = this.$store.getters.getSessionTypes.filter(item => {
          let exist = this.table_data.items.find(cst => {
            return cst.session_type_id === item.id
          })

          if(!exist) return item
        })

        items.push(...filtered)

        return items
      }
    },
    created() {
      this.loadData()
    },
    methods: {
      async loadData() {
        this.table_data.items = await this.axios.get(`api/session-types`)
                .then(({data}) => data.data)
      },
      closeCreateItemDialog() {
        this.create_item_dialog = false;
        this.new_item = {
          session_type_id: '',
          price: '',
          criteria: []
        }
      },
      createItem(e) {
        e.preventDefault()
        this.api_errors = []
        this.axios.post(`api/session-types`, {
          session_type_id: this.new_item.session_type_id,
          price: this.new_item.price,
          criteria: this.new_item.criteria,
        })
          .then(({data}) => {
            this.table_data.items.unshift(data.data)
            this.closeCreateItemDialog()
          })
          .catch(({response}) => { this.api_errors = response.data.errors })
      },
      openSelectedItemDialog(item) {
        this.selected_item = item
        this.selected_item_dialog = true
      },
      closeSelectedItemDialog() {
        this.selected_item_dialog = false
        this.selected_item = null
      },
      updateSelectedItem(e) {
        e.preventDefault()
        this.api_errors = []
        this.axios.put(`api/session-types/${this.selected_item.id}`, this.selected_item)
          .then(() => {
            this.loadData()
            this.closeSelectedItemDialog()
          })
          .catch(({response}) => { this.api_errors = response.data.errors })
      },
      deleteSelectedItem() {
        let url = `api/session-types/${this.selected_item.id}`
        this.axios.delete(url)
          .then(() => {
            this.loadData()
            this.closeSelectedItemDialog()
          })
      }
    }
  }
</script>
